import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import DashboardIcon from "~src/assets/images/dashboard_icon.png";
import { styled } from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import InsightsIcon from "@mui/icons-material/Insights";
import CachedIcon from "@mui/icons-material/Cached";
import { useDashboards } from "../../data/dashboards";
import { NAVBAR_BLUE } from "~src/data/constant";
import callAPI from "../../utils/callAPI";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import PolylineIcon from "@mui/icons-material/Polyline";
import DetailDashboard from "../Forecasting/components/dialogueBox";
const ModifiedListItemIcon = styled(ListItemIcon)(() => ({ minWidth: "20px" }));
import { SyncLoader } from "react-spinners";
import { NAVBAR_BLUE, WHITE } from "~src/data/constant";

const Dropdown = ({ pathName, ToggleForecast, setOnWorkspace }) => {
  // console.log("Dropdown", pathName);
  const { dashboards, loading, setLoading, error, fetchDashboardList } =
    useDashboards();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [openDashboard, setOpenDashboard] = useState(false);
  const [clickedID, setClickedID] = useState(null);

  const handleItemClick = (id) => {
    ToggleForecast();
    setOnWorkspace(false);
    setOpenDashboard(true);
    setClickedID(id);
  };

  const menuItems = [
    "Premium Prediction",
    "Likelihood of Purchase",
    "Claim Amount Forecast",
    "Fraud Detection",
    // "Provider Fraud Detection",
    // "Member Fraud Detection",
    "Member Churn Prediction",
    "Forecasting"
  ];
  const nav = [
    "Premium",
    "likelihood",
    "claimAmountForecast",
    "fraudDetection",
    // "fraudDetectionMember",
    "churnMember",
    "forecasting"
  ];

  return (
    <div>
      <Paper elevation={0} square>
        <div style={{ height: "auto", marginTop: 50 }}>
          {/* <ListItem button onClick={handleMenuOpen}>
            <ModifiedListItemIcon>
              <InsightsIcon
                sx={{ fontSize: "15px" }}
                color={pathName === "/Forecasting" ? "primary" : ""}
              />
            </ModifiedListItemIcon>
            <ListItemText
              disableTypography
              className="ms-2"
              primary={
                <Typography variant="body2" style={{ fontSize: 14 }}>
                  Forecasting
                </Typography>
              }
            />
          </ListItem> */}

          <Typography variant="h5" sx={{marginLeft:5}}>
            Forecasting
          </Typography>

          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{ elevation: 0, style: { margin: "4px" } }}
          > */}
          <div className="mt-10 ml-6">
            {loading ? (
              <div className="w-100 d-flex align-items-center justify-content-center">
                <SyncLoader size={10} color={NAVBAR_BLUE} />
              </div>
            ) : error ? (
              <MenuItem disabled>{error}</MenuItem>
            ) : (
              <Paper
                elevation={0}
                square
                // style={{
                //   boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
                // }}
              >
                <div
                  style={{
                    marginTop: "-0.9rem",
                  }}
                >
                  {/* <MenuItem divider /> */}

                  <div className="flex flex-col items-start">
                    {menuItems.map((menuItem, index) => {
                      const menuItemText = menuItem;
                      const navigation = nav[index];

                      return (
                        <MenuItem
                          key={`Nav-${index}`}
                          className="flex justify-start dashboard_listItem"
                          style={{
                            fontSize: "12px",
                            background: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleItemClick(index + 1);
                          }}
                          component={Link}
                          to={`/forecasting/${navigation}`}
                        >
                          <div className="bold-hover flex">
                            <img
                              // className="me-1"
                              className="mr-1"
                              src={DashboardIcon}
                              alt=""
                              height={20}
                              width={20}
                            />
                            <span style={{ width: "calc(100% - 26px)" }}>
                              {menuItemText}
                            </span>
                          </div>
                        </MenuItem>
                      );
                    })}
                  </div>
                </div>
              </Paper>
            )}
          </div>
          {/* </Menu> */}
        </div>
      </Paper>
    </div>
  );
};

export default Dropdown;
